<template>
  <div class="column is-9">
    <div class="is-border is-radius-large has-bg-white content content-guide">
      <div class="column is-border-bottom is-paddingless-bottom">
        <h1>Résultat de recherche <span class="has-text-info">{{query}}</span></h1>
      </div>
      <div class="secret" v-if="query === 'godzilla'">
        <img src="https://media.giphy.com/media/VO2MiYWK4SRsk/giphy.gif">
        <img src="https://media.giphy.com/media/7tUFxA4PSWwOQ/giphy.gif">
        <img src="https://media.giphy.com/media/j11ks3ZRsbvB6/giphy.gif">
        <img src="https://media.giphy.com/media/WwNtKiEuKH6FO/giphy.gif">
      </div>
      <ul class="resultats-guide" :key="item.id" v-for="item in highlightcontent">
        <li>
          <router-link class="column" :to="{ name: 'Page', params: { pageId: item.redirectId, rubricId : item.rubricRedirectId }}">
            <span v-html="item.name"></span>
            <div v-html="item.abstract"></div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<!-- Partie script -->
<script>
import algoliasearch from 'algoliasearch'
import { isNil } from 'lodash'
import { mapState } from 'vuex'
const client = algoliasearch('OHIN43ICYM', '8ec480f21144dbcf12065d33e446f7fb')
const index = client.initIndex('FAQ_PAGE')

export default {
  name: 'SearchResult',
  computed: {
    authorizedContents () {
      return this.contents.filter(x => {
        if (isNil(x.destinations) && isNil(x.rubricDestinations)) {
          return true
        } else if (x.destinations.includes(this.profil) && this.profil != null && x.rubricDestinations.includes(this.profil)) {
          return true
        } else {
          return false
        }
      })
    },
    xauthorizedContents () {
      let tabcontent = []
      this.contents.forEach(e => {
        let content = e
        console.log(content)
        if (isNil(content.destinations) && isNil(content.rubricDestinations)) {
          tabcontent.push(content)
        } else if (
          content.destinations.includes(this.profil) &&
          this.profil != null &&
          content.rubricDestinations.includes(this.profil)
        ) {
          tabcontent.push(content)
        }
      })
      return tabcontent
    },
    highlightcontent () {
      return this.authorizedContents.map(x => {
        x.name = x.name.substr(3)
        if (this.query.length >= 3) {
          if (x.abstract) {
            x.abstract = this.highlight(x.abstract, this.query)
          }
          if (x.name) {
            x.name = this.highlight(x.name, this.query)
          }
        }
        return x
      })
    },
    ...mapState(['link', 'profil', 'tokentab'])
  },
  data () {
    return {
      query: null,
      contents: []
    }
  },
  created () {
    this.query = this.$route.query.query
    this.search()
  },
  watch: {
    $route () {
      this.query = this.$route.query.query
      this.search()
      // let querydata = this.query
    }
  },
  methods: {
    search () {
      index.search(
        {
          query: this.$route.query.query,
          hitsPerPage: 50
        },
        (err, content) => {
          this.contents = content.hits
          if (err) throw err
          console.log(content.hits)
        }
      )
    },
    highlight (text, keywords) {
      return text.replace(
        new RegExp(keywords, 'gi'),
        '<span class="highlighted">$&</span>'
      )
    }
  }
}
</script>

<style>
.highlighted {
  display: inline !important ;
  position: relative !important ;
  font-size: 1.285rem !important ;
  color: #80b4eb !important ;
  margin-bottom: 0.5rem !important;
}
</style>
